export const REVIEW_TEXT_MIN = 20;
export const REVIEW_TEXT_MAX = 2000;
export const REVIEW_REPLY_MAX = 1000;
